import { useMemo } from "react";
import classNames from "classnames";
import i18n from "i18next";

interface BadgeProps {
    title: string;
    onClick: () => void;
    isActive: boolean;
    className?: string;
}
const Badge = ({ title, onClick, isActive, className = "" }: BadgeProps) => {
    const titleLabel = useMemo(
        () =>
            ({
                cm: i18n.t("height_unit_cm"),
                "ft/in": i18n.t("height_unit_ft_in"),
                pounds: i18n.t("pounds"),
                kilograms: i18n.t("kilograms"),
            })[title],
        [title]
    );

    return (
        <button
            key={title}
            onClick={onClick}
            className={classNames("rounded-full px-6 py-2 text-zing-12-15 uppercase", className, {
                "bg-zing-blue-200 text-white female:bg-zing-warm-tangerine-400 female:text-white":
                    isActive,
                "bg-zing-black-200 text-zing-gray-400 female:bg-zing-warm-tangerine-100 female:text-black":
                    !isActive,
            })}
        >
            {titleLabel}
        </button>
    );
};

export default Badge;
